import { faCircleXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from 'aa_common/front-end/antd'
import { Row, Typography } from 'antd'
import { getNs } from 'common/i18n-config'

import { NoResultWrapper, TopSection, Troubleshooting } from '../styles'

const { t, useNsReady } = getNs(['components/organisms/assets/asset-form'])
const { Text, Title } = Typography
export const AINoResult = ({ onTryAgain }: { onTryAgain?: () => void }) => {
  useNsReady()
  return (
    <NoResultWrapper>
      <TopSection>
        <FontAwesomeIcon className="icon" icon={faCircleXmark} />
        <Title level={5}>{t('ai_suggestion_not_found.title')}</Title>
        <Text>{t('ai_suggestion_not_found.description')}</Text>
      </TopSection>

      <Troubleshooting>
        <Row>
          <Text>{t('ai_suggestion_not_found.troubleshooting_heading')}</Text>
        </Row>
        <ul>
          <li>
            <Row>
              <Text>{t('ai_suggestion_not_found.troubleshooting_tip1')}</Text>
            </Row>
            <Row>
              <Text className="example">{t('ai_suggestion_not_found.troubleshooting_tip1_example')}</Text>
            </Row>
          </li>
          <li>
            <Text>{t('ai_suggestion_not_found.troubleshooting_tip2')}</Text>
          </li>
          <li>
            <Text>{t('ai_suggestion_not_found.troubleshooting_tip3')}</Text>
          </li>
        </ul>
      </Troubleshooting>

      <Button color="blue" onClick={onTryAgain}>
        {t('try_again')}
      </Button>
    </NoResultWrapper>
  )
}
